import { useState } from 'react'

const usePasswordInputField = () => {
  const [showPassword, setShowPassword] = useState(false)

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword)
  }

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
  }

  return {
    showPassword,
    handleClickShowPassword,
    handleMouseDownPassword
  }
}

export default usePasswordInputField
